import type {
  ClientId,
  AvrId,
  EquipmentId,
  InspectionId
} from "../../shared/kernel/identifiers.js";

export type AvrCriticality = 'LOW' | 'MODERATE' | 'HIGH' | 'CRITICAL' | 'UNCLASSIFIED';

export interface RemainingLifeAssessment {
  id: AvrId;
  clientId: ClientId;
  equipmentId: EquipmentId;
  inspectionId: InspectionId;
  
  // Data points
  previousThickness: number | null; // mm
  currentThickness: number; // mm
  minimumThickness: number; // mm
  
  periodYears: number | null; // years between previous and current
  
  // Computed values
  corrosionRate: number | null; // TC (mm/year)
  remainingLife: number | null; // VR (years)
  
  criticality: AvrCriticality;
  
  referenceImage: string | null; // Croqui
  
  createdAt: string;
  updatedAt: string;
}

/**
 * Calculates VR criticality based on the project's default configuration.
 * Note: This is a project configuration, not a universal normative rule.
 */
export function determineAvrCriticality(
  currentThickness: number, 
  minimumThickness: number, 
  remainingLife: number | null
): AvrCriticality {
  if (currentThickness <= minimumThickness) {
    return 'CRITICAL';
  }
  
  if (remainingLife === null) {
    return 'UNCLASSIFIED';
  }
  
  if (remainingLife < 1) return 'CRITICAL';
  if (remainingLife >= 1 && remainingLife < 3) return 'HIGH';
  if (remainingLife >= 3 && remainingLife <= 5) return 'MODERATE';
  
  return 'LOW'; // remainingLife > 5
}
